module.exports = __webpack_public_path__ + "static/img/fw_pic1.d137815.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/fw_pic1.jpg
// module id = az6G
// module chunks = 37